export const CHANGE_BLOCK_LEVEL = 'CHANGE_BLOCK_LEVEL'

export const LOCALE_PREFIX =
    'scenes.Gnosus.components.Workspace.components.HocBlock.components.BlockTitle.components.LevelPicker'
